import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function deleteDocumentFailure(draft: Draft<IInterventionData>) {
  draft.deleteDocument.config.isLoading = false;
}

export default deleteDocumentFailure;
